export default {
  email: {
    type: '',
    email: ''
  },
  address: {
    type: '',
    street: '',
    number: '',
    postCode: '',
    state: '',
    city: '',
    poBox: '',
    country: '',
    region: ''
  },
  communication: {
    type: '',
    phone: ''
  }
};
